<app-header [title]="'Welcome'"></app-header>
<div class="redirect-pge">
  <div class="redirect-midd">
    <h4>Weclome to iAR</h4>
    <span>Please ask contact your superior if you face any problem !</span>
  </div>
</div>